export const getRandomString = (string_length: number = 5) => {
    let randomStringLength = 5;
    if (typeof string_length !== "undefined") randomStringLength = string_length;
    let result = "";
    let characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let charactersLength = characters.length;
    for (let i = 0; i < randomStringLength; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};

export const sliceString = (string:string, length:number = 13, point:boolean = true) => {
    if (typeof string !== "string") {
        return ''
    }
    if (string?.length) {
        return string && string.length > length ? string.slice(0, length) + (point ? '...' : '') : string;
    }

};

/**
 * «Маршрут №Т01 (Залізничний вокзал - Погулянка)» → «Маршрут №Т01».
 *
 * The terminals in brackets stretch a list row over several lines, while the route number on its own
 * is already unambiguous. Cut for display only: search keeps matching the full name, so a route is
 * still found by its terminal, and the full name stays in the tooltip.
 */
export const shortRouteLabel = (label?: string | null): string => {
    if (!label) {
        return ''
    }
    const bracket = label.indexOf(' (')
    return bracket > 0 ? label.slice(0, bracket) : label
};
